import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';

import { log } from '../../services/utils';

import styles from './table.module.css';
import { Loader } from 'semantic-ui-react';

const TableBody = ( {
	currentRowRight,
	getTableBodyProps,
	highlightCurrentRow,
	isLoading,
	onClick,
	page,
	pageSize,
	prepareRow,
	recordCount,
	rowStyles,
	showEmptyRows
} ) => {
	const renderEmptyRows = useCallback( () => {
		let emptyRows = [];

		if ( page.length && page.length < pageSize ) {
			const emptyRowsToRender = pageSize - page.length;

			for ( let i = 0; i < emptyRowsToRender; i++ ) {
				emptyRows.push( <div
					{ ...page[ 0 ].getRowProps }
					key={ i + page.length }
					className={ styles.tableRow }
				>
					{ page[ 0 ].cells.map( ( cell, i ) => (
						<div
							{ ...cell.getCellProps() }
							key={ i }
							className={ styles.tableCell }
						>
							&nbsp;
						</div>
					) ) }
				</div> );
			}
		}

		return emptyRows;
	}, [
		page,
		pageSize
	] );

	const applyRowStyles = useCallback( row => rowStyles.reduce( (
		acc,
		{
			condition,
			style
		}
	) => ( {
		...acc,
		...condition( row ) && style
	} ), {} ), [ rowStyles ] );

	if ( isLoading ) {
		return (
			<div className={ styles.noResults }>
				<Loader active inline="centered" />
			</div>
		);
	}

	return (
		<div
			{ ...getTableBodyProps() }
			className={ styles.tableBody }
		>
			{ log( '- tableBody' ) }
			{ page.length
				? page.map( ( row, i ) => {
					prepareRow( row );

					return (
						<div
							{ ...row.getRowProps }
							key={ i }
							className={ `${ styles.tableRow } ${ highlightCurrentRow ? styles.highlight : '' }` }
							style={ {
								...row.getRowProps.style,
								...applyRowStyles( row.original )
							} }
							onClick={ () => {
								onClick?.( row.original.id );
							} }
						>
							{ row.cells.map( ( cell, i ) => (
								<div
									{ ...cell.getCellProps() }
									key={ i }
									className={ styles.tableCell }
								>
									{ cell.render( 'Cell', { editable: false } ) }
								</div>
							) ) }
							{ currentRowRight
								? <div className={ styles.currentRowRight }>
									{ currentRowRight( row.original ) }
								</div>
								: null
							}
						</div>
					);
				} )
				: <div className={ styles.noResults }>
					<p>No records found.</p>
				</div>
			}
			{ showEmptyRows
				? renderEmptyRows()
				: null
			}
			{ recordCount }
		</div>
	);
};

TableBody.propTypes = {
	currentRowRight: PropTypes.func,
	getTableBodyProps: PropTypes.func.isRequired,
	highlightCurrentRow: PropTypes.bool,
	isLoading: PropTypes.bool,
	onClick: PropTypes.func,
	page: PropTypes.array.isRequired,
	pageSize: PropTypes.number.isRequired,
	prepareRow: PropTypes.func.isRequired,
	recordCount: PropTypes.node,
	rowStyles: PropTypes.arrayOf( PropTypes.shape( {
		style: PropTypes.object,
		condition: PropTypes.func
	} ) ),
	showEmptyRows: PropTypes.bool
};

export default memo( TableBody );
